/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CandidateStatus } from '../enums/candidate-status';
import { DisplayBillingRate } from '../enums/display-billing-rate';
import { RejectionLossCode } from '../enums/rejection-loss-code';
import { RollOffReasonCode } from '../enums/roll-off-reason-code';
import { CandidateEntity } from './candidate-entity';
import { CandidateReputationClarificationEntity } from './candidate-reputation-clarification-entity';
import { OpportunityEntity } from './opportunity-entity';
import { PositionEntity } from './position-entity';
export class CandidateOpportunityEntity extends Entity {
  annualSalary: number | null = null;
  candidate: CandidateEntity | null = null;
  candidateAvailabilityNotes: string | null = null;
  candidateBaseAnnualSalary: number | null = null;
  candidateBonusPercentage: number | null = null;
  candidateExperienceNotes: string | null = null;
  candidateExploringOutsideRoles: string | null = null;
  candidateId: string | null = null;
  candidateInterestedAt: string | null = null;
  candidateIsInterested: boolean | null = null;
  candidatePlannedTimeOffNotes: string | null = null;
  candidateReasonForNo: string | null = null;
  candidateReputationClarification: CandidateReputationClarificationEntity | null = null;
  candidateStatus: CandidateStatus | null = null;
  candidateStatusMessage: string | null = null;
  candidateStatusMessageDismissedAt: string | null = null;
  candidateStatusUpdatedAt: string | null = null;
  candidateSubmittedAt: string | null = null;
  candidateWorkscheduleAnnualHours: number | null = null;
  compensationType: string | null = null;
  consultant1099UtilizationWarning: boolean | null = null;
  createdAt: string | null = null;
  createdBy: string | null = null;
  displayBillingRate: DisplayBillingRate | null = null;
  ebillingMandateMultiple: number | null = null;
  exchangeRate: number | null = null;
  hasBeenWarmed: boolean | null = null;
  hasNoConflictOfInterest: boolean | null = null;
  hourlyRate: number | null = null;
  hourlyRateBurdened: number | null = null;
  hourlySalary: number | null = null;
  id: string = '';
  isActiveForSubmission: boolean | null = null;
  isPriorityTalentAtSelected: boolean | null = null;
  lastUpdatedBy: string | null = null;
  marginApprovalCeiling: number | null = null;
  marginApprovalFloor: number | null = null;
  marginFloorPct: number | null = null;
  marginTargetPct: number | null = null;
  marginUpperPct: number | null = null;
  meetsMinPayRequirements: boolean | null = null;
  onboardingDetails: Record<string, unknown> | null = null;
  onboardingEmailSentAt: string | null = null;
  openToLowerEsc: boolean | null = null;
  openToLowerEscCompensationAmount: number | null = null;
  openToLowerEscCompensationPercentage: number | null = null;
  opportunity: OpportunityEntity | null = null;
  opportunityId: string | null = null;
  pinnedByClient: boolean = false;
  position: PositionEntity | null = null;
  positionId: string | null = null;
  previousCandidateStatus: string | null = null;
  previousPositiveCandidateStatus: string | null = null;
  productBurdenRateMultiple: number | null = null;
  productPremiumRateMultiple: number | null = null;
  proposedCostTarget: number | null = null;
  proposedHourlyCompCandidateCurrency: number | null = null;
  proposedHourlyCompensation: number | null = null;
  proposedHourlyRate: number | null = null;
  proposedMarginTarget: number | null = null;
  rejectionLossCode: RejectionLossCode | null = null;
  rejectionLossCodeCustomMessage: string | null = null;
  rollOffReason: RollOffReasonCode | null = null;
  salesforceQuoteLineId: string | null = null;
  showCandidateReputation: boolean = false;
  submissionDescription: string | null = null;
  submissionRank: number | null = null;
  updatedAt: string | null = null;
  viewedOnHistoryAt: string | null = null;
  baseHourlyCompensation?: number | null = null;
  calculatedMarginTarget?: number | null = null;
  candidateEngagedAtLowerEsc?: boolean | null = null;
  enableReputationSharing?: boolean | null = null;
  interviewRequested?: boolean | null = null;
  static override key = 'CandidateOpportunity';
  static override get schema() {
    return {
      candidate: CandidateEntity,
      candidateReputationClarification: CandidateReputationClarificationEntity,
      opportunity: OpportunityEntity,
      position: PositionEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateOpportunity' in input
    ) {
      const { CandidateOpportunity: wrapped, ...rest } = input as {
        CandidateOpportunity: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}